import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';

import ErrorPage from 'components/Errors/ErrorPage';

const UnlicensedError = ({ intl }) => <ErrorPage title={ intl.formatMessage({ id: 'unlicensedError.title' }) } showButton type="server">
  <FormattedHTMLMessage id="unlicensedError.content" />
</ErrorPage>;

UnlicensedError.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired
};

export default injectIntl(UnlicensedError);
